import React from 'react';

import { connect } from 'react-redux';
import { isFieldReadOnly } from 'bundles/apex/deals/helpers/fields';
import { setDate } from 'bundles/apex/deals/form/store/deal/actions';

import DealField, { propTypes } from 'bundles/apex/deals/form/fields/field';
import DateFormGroup from 'bundles/apex/dates/form_group';

export function CriticalDateField({ deal, fields, invalid, label, name, required, setDate }) {
  return (
    <DateFormGroup
      className="date-field"
      deal={deal}
      disabled={isFieldReadOnly(name, deal)}
      fields={fields}
      hasError={invalid}
      label={label}
      name={name}
      required={required}
      value={deal[name]}
      onValueChange={date => setDate(name, date)}
    />
  );
}

CriticalDateField.propTypes = propTypes;

const mapStateToProps = state => ({
  fields: state.fields,
});

const mapDispatchToProps = {
  setDate,
};

export default DealField(connect(mapStateToProps, mapDispatchToProps)(CriticalDateField));
